module.exports = __webpack_public_path__ + "img/52114133_L.2e6548f7.png";